import React, { useCallback } from 'react'
import styles from './Player.module.scss'
import { PlayerAvatar } from '../PlayerAvatar/PlayerAvatar'
import { PlayerData } from '../../metrics_server/players/types'
import { PlayerForm } from '../../metrics_server/players/components/PlayerForm/PlayerForm'
import { toggleModal } from '../Modal/modalActions'
import { useAppDispatch } from '../../store/hooks'

export interface PlayerProps {
  player: PlayerData
  size?: 's' | 'm' | 'l'
  id?: string
}

export const Player: React.FC<PlayerProps> = ({ player, size = 's', id }) => {
  const dispatch = useAppDispatch()

  // Determine tile size based on the size prop
  const tileSize =
    size === 's'
      ? styles.tileSmall
      : size === 'm'
      ? styles.tileMedium
      : styles.tileLarge

  const handleEditClick = useCallback(() => {
    dispatch(
      toggleModal({
        active: true,
        type: 'form',
        wrapper: true,
        width: 'auto',
        ChildComponent: () => (
          <PlayerForm
            handleProceed={() => dispatch(toggleModal({}))}
            playerData={player}
          />
        ),
        className: 'modalSmall'
      })
    )
  }, [dispatch, player])

  if (!player) return null

  return (
    <div
      className={`${styles.playerTileContainer} ${tileSize}`}
      id={player.id || id}
      onClick={handleEditClick}
    >
      {player.img ? (
        <div className={styles.imageContainer}>
          <img
            id={player.id}
            className={styles.img}
            src={player.img}
            alt={`${player.firstName} ${player.lastName}`}
          />
        </div>
      ) : (
        <div className={styles.avatarContainer}>
          <PlayerAvatar autoScale />
        </div>
      )}

      <div className={styles.playerDetailsContainer}>
        <p className={styles.nameInfo}>
          <b>{player.lastName}</b>,
        </p>
        <div className={styles.tagAndNumberContainer}>
          <div className={styles.tagInfo}>{player.firstName}</div>
          <p className={styles.number}>{player?.number}</p>
        </div>
      </div>
    </div>
  )
}
